import { $advancedSearchForm, AdvancedSearchOperation, IAdvancedSearchRow } from './advanced-search.component';
import { SharedObjectUtility } from '../../../../shared/utils/object.utility';

export class AdvancedSearchUtil {
  // eslint-disable-next-line consistent-return
  private static shouldFilter<T>(filter: IAdvancedSearchRow, value: T, keysMap: Record<string, string>): boolean {
    if (filter[$advancedSearchForm.value]?.trim().length === 0) {
      return true;
    }

    const propertyValue: string | undefined = SharedObjectUtility.getProperty(
      value,
      keysMap[filter[$advancedSearchForm.fieldToSearch]],
    );

    if (typeof propertyValue === 'undefined' || propertyValue === null) {
      return true;
    }

    switch (filter[$advancedSearchForm.operation]) {
      case AdvancedSearchOperation.contains:
        return String(propertyValue).toLowerCase().includes(filter[$advancedSearchForm.value].toLowerCase());
      case AdvancedSearchOperation.does_not_contain:
        return !String(propertyValue).toLowerCase().includes(filter[$advancedSearchForm.value].toLowerCase());
      case AdvancedSearchOperation.ends_with:
        return String(propertyValue).toLowerCase().endsWith(filter[$advancedSearchForm.value].toLowerCase());
      case AdvancedSearchOperation.starts_with:
        return String(propertyValue).toLowerCase().startsWith(filter[$advancedSearchForm.value].toLowerCase());
      case AdvancedSearchOperation.regex:
        return new RegExp(filter[$advancedSearchForm.value]).test(String(propertyValue));
      // no default
    }
  }

  public static filterValues<T>(values: T[], filterRows: IAdvancedSearchRow[], keysMap: Record<string, string>): T[] {
    return values.filter((value: T): boolean => AdvancedSearchUtil.conformsFilters(value, filterRows, keysMap));
  }

  public static conformsFilters<T>(value: T, filters: IAdvancedSearchRow[], keysMap: Record<string, string>): boolean {
    if (!Array.isArray(filters)) {
      return true;
    }

    return filters.every((filter: IAdvancedSearchRow): boolean => {
      return AdvancedSearchUtil.shouldFilter(filter, value, keysMap);
    });
  }
}
